import type { KeyPrefix } from 'i18next';
import { useTranslation } from 'react-i18next';

export function useScreenTranslations<TKeyPrefix extends KeyPrefix<'common'>>(
  screenName: TKeyPrefix,
) {
  return useTranslation<'common', TKeyPrefix>('common', {
    keyPrefix: screenName,
  });
}
